import React from 'react';
import './Select.css';

function Select(props){
    const {
		label,
		labelId,
		labelClass,
		selectId,
		selectClass,
		handleChange,
		handleValidation,
		value,
		placeHolder,
		isRequired,
        options
	} = props;

	let _labelClass = labelClass ? labelClass : "text_input_label";
	let _selectClass = selectClass ? selectClass : "select_menu";

	if ( handleValidation && !handleValidation( value ) ) {
		_selectClass += " invalidSelect";
	}

    const selectOptions = options.map( (option, i) => <option key={i} className="select_option" value={ option }>{ option }</option> );
	let _placeHolder = placeHolder === undefined ? 'Select' : placeHolder;
	let _value = options.includes( value ) ? value : _placeHolder;

	return (
		<>
			{
				label &&
				<label
					className={ _labelClass }
					id={ labelId }
				>
					{ label }{ isRequired && <span className="required">*</span> }
				</label>
			}

			<select
				id={ selectId }
				className={ _selectClass }
				value={ _value }
				onChange={ handleChange }
			>
                <option disabled>{ _placeHolder }</option>
                { selectOptions }
            </select>
		</>
	);
}

export default Select;